import * as go from 'gojs';
import { getImageMobileVSI } from 'unitData/Mobile/VSI/getImageMobileVSI';
import { alignPorts } from 'unitData/Mobile/VSI/vsiData';
import {
  getImageBinding,
  getMobileInputPort,
  getMobileOutputPort,
  makeNode,
  mobileUnitDefaultOptions,
} from '../../utils';
import type { MobileUnitBaseNodeData } from 'gojs/types';

const MobileVSITemplate = makeNode(
  getImageBinding('', (node: MobileUnitBaseNodeData) =>
    getImageMobileVSI(node.model, node.configuration.configKey),
  ),
  [
    getMobileOutputPort(0, alignPorts),
    getMobileOutputPort(1, alignPorts),
    getMobileOutputPort(2, alignPorts),
    getMobileOutputPort(3, alignPorts),
    getMobileOutputPort(4, alignPorts),
    getMobileInputPort((node) => {
      return node.mirrored
        ? new go.Spot(1 - 5 / 12, 0)
        : new go.Spot(5 / 12, 0);
    }),
  ],
  { ...mobileUnitDefaultOptions },
);

export default MobileVSITemplate;
